import { render } from "./CustomDatepicker.vue?vue&type=template&id=4c3942e4&scoped=true&ts=true"
import script from "./CustomDatepicker.vue?vue&type=script&lang=ts"
export * from "./CustomDatepicker.vue?vue&type=script&lang=ts"

import "./CustomDatepicker.vue?vue&type=style&index=0&id=4c3942e4&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3942e4"]])

export default __exports__